import React, { forwardRef } from 'react';

import Icon, { ICON_TYPES } from '@commons/Icon';

import { isV1 } from '@components/CookieBanner/shared/utils';

import styles from './cookieBannerPanelLink.scss';

interface CookieBannerPanelLinkProps {
  version: unknown;
  onClick: (...args: unknown[]) => unknown;
  children: React.ReactNode;
}

const CookieBannerPanelLink = forwardRef<HTMLElement, CookieBannerPanelLinkProps>(({ version, onClick, children, id }, ref) => (
  <button className={styles.anchor} onClick={onClick} ref={ref}>
    {/* eslint-disable-next-line react/no-danger */}
    <span dangerouslySetInnerHTML={{ __html: children }} />
    {isV1(version) && <Icon type={ICON_TYPES.ARROW_RIGHT} />}
  </button>
));

export default CookieBannerPanelLink;
